<template>
  <section class="admin-content" id="contact-search">
    <!-- <Navbar/> -->
    <main class="admin-main">
      <section>
        <div class="container row">
          <div class="col-md-12" v-if="students.length > 0">
            <div
              class="alert alert-border-info alert-dismissible fade show"
              role="alert"
            >
              <div class="d-flex">
                <div class="icon">
                  <i class="icon mdi mdi-alert-circle-outline"></i>
                </div>
                <div class="row col-md-12">
                  <router-link :to="{ path: '/offline-sync' }">
                    <button
                      type="button"
                      class="btn btn-info align-right"
                      style="margin-left: 10px"
                    >
                      Start Syncing
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12" v-show="showinput">
            <div class="text-center">
              <h3 class="h3">(Offline) Bio Data Form</h3>
              <p>
                (All fields marked with <span class="text-danger">*</span> are
                compulsory)
              </p>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputCity"
                  >Select Sector <span class="text-danger">*</span></label
                >
                <select class="form-control" v-model="sector">
                  <option value="formal">Formal Sector</option>
                  <option value="informal">Informal Sector</option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputCity"
                  >Select Plan Type <span class="text-danger">*</span></label
                >
                <select class="form-control" v-model="newStudent.plan_type">
                  <option value="Family">Family</option>
                  <option value="Individual">Individual</option>
                </select>
              </div>

              <div class="col-md-6" v-if="sector == 'formal'">
                <div class="form-group">
                  <label class="info-label d-block mb-1" for="inputCity">Select Formal Sector</label>
                  <select class="form-control" v-model="newStudent.sector">
                    <option value="State Civil Servant">
                      State Civil Servant
                    </option>

                    <option value="LGA Civil Servant">LGA Civil Servant</option>
                    <option value="Universal Basic Education">
                      Universal Basic Education
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group col-md-6" v-if="sector == 'informal'">
                <label class="info-label d-block mb-1"
                  >Informal Sector <span class="text-danger">*</span></label
                >
                <select class="form-control" v-model="newStudent.sector">
                  <option
                    :value="sector"
                    v-for="sector in sectors"
                    :key="sector"
                  >
                    {{ sector }}
                  </option>
                </select>
              </div>

              <div
                class="form-group col-md-6"
                v-if="
                  newStudent.sector == 'State Civil Servant' ||
                  newStudent.sector == 'LGA Civil Servant' ||
                  newStudent.sector == 'Universal Basic Education'
                "
              >
                <label class="info-label d-block mb-1" for="inputEmail4">
                  Computer Number
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="newStudent.salary_number"
                  placeholder="Computer Employment Number"
                  @change="checkEnrollee"
                />
                <p>Compulsory field</p>
              </div>

              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1">Select Enrollee  </label>
                <select
                  class="form-control"
                  v-model="selected_enrollee"
                  @change="selectEnrollee(selected_enrollee)"
                >
                  <option
                    :value="user"
                    v-for="user in validated_enrollee"
                    v-bind:key="user"
                  >
                    <span> {{ user.firstname }} {{ user.lastname }}</span>
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6" v-if="sector == 'informal'">
                <label class="info-label d-block mb-1">Special Needs</label>
                <select
                  class="form-control"
                  v-model="newStudent.category_of_vulnerable_group"
                  @change="maximumDateChild"
                >
                  <option
                    :value="vulnerable"
                    v-for="vulnerable in vulnerables"
                    :key="vulnerable"
                  >
                    {{ vulnerable }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6" v-show="false">
                <label class="info-label d-block mb-1">Sub Category</label>
                <select
                  class="form-control"
                  v-model="newStudent.category_of_vulnerable_group"
                >
                  <option
                    :value="vul"
                    v-for="vul in sub_vulnerables"
                    :key="vul"
                  >
                    {{ vul }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputPassword4">NIN Number</label>
                <input
                  type="text"
                  pattern="\d*"
                  maxlength="11"
                  class="form-control"
                  v-model="newStudent.nimc_number"
                  placeholder="NIN Number"
                />
              </div>
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputPassword4"
                  >Surname <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  :disabled="sector == 'formal' ? true : false "

                  class="form-control"
                  v-model="newStudent.lastname"
                  placeholder="Last Name"
                />
              </div>
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputEmail4"
                  >First Name<span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  :disabled="sector == 'formal' ? true : false "
                  class="form-control"
                  v-model="newStudent.firstname"
                  placeholder="First Name"
                />
              </div>
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputEmail4">Middle Name</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="newStudent.middlename"
                  placeholder="Middle Name"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputPassword4"
                  >Phone Number <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  pattern="\d*"
                  maxlength="11"
                  class="form-control"
                  v-model="client_number"
                  placeholder="Phone Number"
                />
              </div>
              <div class="form-group col-md-6">
                <p>
                  <label class="info-label d-block mb-1" for="inputPassword4"
                    >Date of Birth <span class="text-danger">*</span></label
                  >
                </p>

                <input
                  type="date"
                  :max="maxDate"
                  :min="max_date_child"
                  class="form-control"
                  v-model="newStudent.dob"
                />
              </div>

              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1">Select LGA <span class="text-danger">*</span> </label>

                <select
                  class="form-control"
                  v-model="newStudent.localgovt"
                  @change="getWards()"
                >
                  <option
                    v-for="loc in osun_lgas.data"
                    v-bind:key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.local_name }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1">Select Ward <span class="text-danger">*</span></label>
                <select class="form-control" v-model="newStudent.ward">
                  <option
                    v-for="loc in wards_lga.wards"
                    v-bind:key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.ward_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-row" v-if="sector == 'formal'">
              <div class="form-group col-md-12">
                <label class="info-label d-block mb-1" for="inputCity">Select MDA</label>
                <v-select
                  v-model="newStudent.place_of_work"
                  :options="mda_offline.data"
                  label="name"
                  :value="newStudent.place_of_work"
                  @input="selected_mda"
                ></v-select>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1"
                  >Facility to Access Care
                  <span class="text-danger">*</span>

                  <span
                    class="ml-2 text-info"
                    role="button"
                    @click="getAllFacilities"
                  >
                    get all
                  </span>
                </label>
                <v-select
                  v-model="newStudent.provider_id"
                  :options="osun_providers"
                  label="agency_name"
                  :value="newStudent.provider_id"
                ></v-select>
              </div>

              <div class="col-md-6">
                <label class="info-label d-block mb-1" for="inputCity"
                  >Gender <span class="text-danger">*</span></label
                >
                <select class="form-control" v-model="newStudent.gender">
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputCity">Blood Group</label>
                <select class="form-control" v-model="newStudent.blood">
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1">Marital Status <span class="text-danger">*</span></label>
                <select
                  class="form-control"
                  v-model="newStudent.marital_status"
                >
                  <option value="Married">Married</option>
                  <option value="Widow">Widow</option>
                  <option value="Single">Single</option>
                  <option value="Divorced">Seperated</option>
                  <option value="Divorced">Divorced</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputCity">Genotype</label>
                <select class="form-control" v-model="newStudent.genotype">
                  <option value="AA">AA</option>
                  <option value="AS">AS</option>
                  <option value="SS">SS</option>
                  <option value="AC">AC</option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1" for="inputAddress">Home Address</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="newStudent.address"
                  placeholder="1234 Main St"
                />
              </div>
            </div>

            <div class="form-group">
              <button
                class="btn btn-submit btn-block"
                @click="showImage"
                v-if="client_number.length == 11"
              >
                Proceed to Take Picture
              </button>
              <button
                class="disabled btn btn-info btn-block"
                v-if="client_number.length != 11"
              >
                Proceed to Take Picture
              </button>
            </div>
          </div>

          <div v-show="showcamera" class="container-fluid">
            <h3 class="h3">Client Picture</h3>

            <div class="form-group">
              <div class="row mt-3">
                <div class="col-md-12">
                  <button class="btn btn-default btn-block" @click="showInput">
                    Back
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 p-t-20 p-b-20" v-show="gotoDependent">
                <button
                  @click="modalShow = !modalShow"
                  class="btn btn-submit btn-block"
                >
                  Add Dependent
                </button>
              </div>

              <div>
                <b-modal v-model="modalShow" size="xl">
                  <div class="form-row">
                    <p class="h4 text-center">
                      Do you want to add Dependent(s) for
                      {{ newStudent.firstname }} {{ newStudent.lastname }}
                    </p>

                    <div class="row col-md-12">
                      <div class="col-md-6">
                        <button
                          class="btn btn-submit btn-block"
                          @click="goAddDep"
                        >
                          Yes
                        </button>
                      </div>
                      <div class="col-md-6">
                        <button
                          class="btn btn-dark btn-block"
                          @click="closeDep"
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </div>

              <div class="col-md-12 p-t-6 p-b-20">
                <div
                  class="my-2 col-md-10 offset-md-1"
                  v-if="img && img != 'data:image/png;base64,'"
                >
                  <img :src="`${img}`" class="img-responsive" />
                  <div class="mt-2" v-if="photoOriginal">
                    <button class="btn btn-outline-secondary btn-sm" type="button" @click="cropPhoto(photoOriginal)">
                      <i class="fe fe-crop mr-1"></i> Adjust photo
                    </button>
                  </div>
                </div>

                <button
                  @click="takePicAndroid"
                  class="btn btn-outline-success btn-block"
                >
                  Take Picture <i class="fe fe-camera"></i>
                </button>

                <button class="btn btn-info btn-block mt-2" @click="addUSer">
                  Submit
                </button>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="spinner"
              :can-cancel="false"
              :is-full-page="true"
            ></loading>
          </div>
        </div>
      </section>
      <PhotoCropper ref="photoCropper" />
    </main>
  </section>
</template>
<script>
import { StudentService } from "../../../service/student_service";
// import { WebCam } from "vue-web-cam";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import allfacilitiesJson from "./../../../../public/offline/allfacilities.json";
import lgaswardsJson from "./../../../../public/offline/lgas_wards.json";
import mdaJson from "./../../../../public/offline/mda.json";
import allFormalSectorState from "./../../../../public/offline/civil_servant_state.json";
import allFormalSectorLGA from "./../../../../public/offline/civil_servant_lga.json";
import NewFormalSectorLGA from "./../../../../public/offline/new_lga_workers_data.json";
import OPSStaff from "./../../../../public/offline/ops_staff.json";

import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

import PhotoCropper from "@/components/PhotoCropper.vue";

export default {
  components: { PhotoCropper,
    Loading,
    // WebCam,
  },
  name: "Student",
  props: {
    students: {
      required: true,
      type: Array,
    },
  },
  data: function () {
    return {
      all_formal_workers_state: allFormalSectorState,
      all_formal_workers_lga: allFormalSectorLGA,
      ubec_formal_workers_lga: NewFormalSectorLGA,
      ops_staff: OPSStaff,

      sectors: [
        "Basic Healthcare Provision Fund",
        "State Equity Program",
        "Voluntary Contributor",
        "Vital Contributor",
        "Pro Health International",
        "UNICEF",
        "GAVI",
        "NURTW",
        "KEKE RIDERS",
        "OKADA RIDERS",
        "FARMERS ASSOCIATION",
        "MARKET WOMEN ASSOCIATION",
        "ZAKKAT & ENDOWMENT BOARD",
        "ALGON",
      ],
      vulnerables: [
        "Aged",
        "Children under 5",
        "People with Disabilities",
        "Pregnant Women",
        "Children under 5",
        "Pregnant Women",
        "Women of Child Bearing Age",
      ],
      validated_enrollee: [],
      sub_vulnerables: [],
      max_date_child: "",
      disabler: true,
      img: "data:image/png;base64,",
      photoOriginal: "",
      selectedDate: "",
      disabled: false,
      modalShow: false,
      gotoDependent: false,
      newStudent: null,
      showinput: true,
      showcanvas: true,
      dependents_counter: 0,
      singleuser: "",
      wards: "",
      wards_sync: "",
      facilities_sync: "",
      showcamera: false,
      providers: "",
      selected_provider_id: "",
      selected_lga_id: "631",
      selected_mda_name: "",
      selected_ward_id: "",
      user: null,
      editStudent: {},
      fullPage: true,
      client_number: "0",
      leftfingers: null,
      rightfingers: null,
      twothumbs: null,
      sector: "",
      show: false,
      osun_lgas: lgaswardsJson,
      wards_lga: "",
      osun_providers: allfacilitiesJson,
      mda_offline: mdaJson,
      selected_enrollee: "",
      // tpa_Lga: tpaLGAJson,
      isLoading: false,

      newarray: {
        data: "",
      },
      service: new StudentService(),
    };
  },

  beforeMount: function () {
    this.clear();
    this.user = JSON.parse(localStorage.getItem("user"));
    this.wards_sync = JSON.parse(localStorage.getItem("wards_data"));
    this.facilities_sync = JSON.parse(localStorage.getItem("facilities"));
    this.selected_lga_sync = JSON.parse(localStorage.getItem("selected_lga"));
  },

  computed: {
    getplaceofWork() {
      if (this.newStudent.place_of_work == null) {
        return null;
      } else {
        return this.newStudent.place_of_work.name;
      }
    },

    maxDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      today = yyyy + "-" + mm + "-" + dd;

      return today;
    },
  },

  methods: {
    updateSub() {
      if (
        this.newStudent.category_of_vulnerable_group ==
        "Persons with Disability"
      ) {
        this.sub_vulnerables = [
          "Blind",
          "Deaf",
          "Dwarf",
          "Albino",
          "Mentally Retarded",
          "Paralytic (Physical Disability)",
        ];

        console.log("leeeo");
      }

      if (this.newStudent.category_of_vulnerable_group == "Chronically ill") {
        this.sub_vulnerables = ["Sickle Cell Disease", "PLHIV", "TB/Leprosy"];
      }

      if (
        this.newStudent.category_of_vulnerable_group == "Pregnant women" ||
        this.newStudent.category_of_vulnerable_group == "Children under 5" ||
        this.newStudent.category_of_vulnerable_group == "Elderly above 60" ||
        this.newStudent.category_of_vulnerable_group == "Retirees" ||
        this.newStudent.category_of_vulnerable_group == "Widows" ||
        this.newStudent.category_of_vulnerable_group == "Poor, below $1 a day"
      ) {
        this.sub_vulnerables = [];
      }
    },
    // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
    async cropPhoto(src) {
      const cropped = await this.$refs.photoCropper.open(src);
      if (!cropped) return false;
      this.photoOriginal = src;
      this.img = cropped;
      return true;
    },
    async takePicAndroid() {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.Base64,
        source: CameraSource.Camera,
      });

      var imageUrl = image.base64String;
      if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;

      return imageUrl;
    },

    maximumDateChild() {
      this.updateSub();
      if (this.newStudent.category_of_vulnerable_group == "Children under 5") {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear() - 5;
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        today = yyyy + "-" + mm + "-" + dd;
        this.max_date_child = today;
      }

      if (this.newStudent.category_of_vulnerable_group == "Children of PWDs") {
        var todays = new Date();
        var dds = todays.getDate();
        var mms = todays.getMonth() + 1;
        var yyyys = todays.getFullYear() - 18;
        if (dds < 10) {
          dds = "0" + dds;
        }
        if (mms < 10) {
          mms = "0" + mms;
        }
        todays = yyyys + "-" + mms + "-" + dds;
        this.max_date_child = todays;
      }

      if (
        this.newStudent.category_of_vulnerable_group != "Children of PWDs" &&
        this.newStudent.category_of_vulnerable_group != "Children under 5"
      ) {
        this.max_date_child = "";
      }
    },
    selected_provider(value) {
      this.selected_provider_id = value.id;
    },
    selected_ward(value) {
      this.selected_ward_id = value.id;
    },
    selected_lga(value) {
      this.selected_lga_id = value.id;
    },
    selected_mda(value) {
      this.selected_mda_name = value.name;
    },
    getWards() {
      // let newarr = [1,2, 3].filter(x=> x<2)
      let osunlgaarray = this.osun_lgas.data;
      let formatter = osunlgaarray.filter(
        (x) => x.id == this.newStudent.localgovt
      );
      this.wards_lga = formatter[0];
      console.log(formatter);
      this.getProviderLGA();
    },

    getProviderLGA() {
      //Query All facilities first
      this.osun_providers = allfacilitiesJson;

      //then filter by specfic lga
      let osunlgaarray = this.osun_providers;
      let formatter = osunlgaarray.filter(
        (x) => x.localgovt == this.newStudent.localgovt
      );
      this.osun_providers = formatter;
      console.log(formatter);
    },

    getAllFacilities() {
      this.osun_providers = allfacilitiesJson;
      console.log(allfacilitiesJson);
    },
    showInput() {
      this.showinput = true;
      this.showcamera = false;
      this.showfinger = false;
    },
    showImage() {
      this.showinput = false;
      this.showcamera = true;
    },
    goAddDep() {
      let singleenrollee = localStorage.setItem(
        "offline_user",
        JSON.stringify(this.newStudent)
      );
      localStorage.setItem("phone_number", this.client_number);
      localStorage.setItem("provider_id", this.selected_provider_id);
      singleenrollee;
      this.$router.push("/add/dependent-offline");
    },

    addUSer() {
      this.addUserEmployee();
    },

    async addUserEmployee() {
      try {
        // const studentsAdded = await this.service.addStudent(this.newStudent);
        const studentsAdded = await this.service.addStudent({
          // firstname: this.newStudent.firstname,
          firstname: this.newStudent.firstname,
          lastname: this.newStudent.lastname,
          middlename: this.newStudent.middlename,
          nimc_number: this.newStudent.nimc_number,
          provider_id: this.newStudent.provider_id.id,
          localgovt: this.newStudent.localgovt,
          plan_type: this.newStudent.plan_type,
          ward: this.newStudent.ward,
          phone_number: this.client_number,
          dob: this.newStudent.dob,
          expiry_date: this.newStudent.expiry_date,
          type: "client",
          gender: this.newStudent.gender,
          user_image: this.img,
          sector: this.newStudent.sector,
          sectorType: this.sector,
          marital_status: this.newStudent.marital_status,
          blood: this.newStudent.blood,
          salary_number: this.newStudent.client_number,
          // place_of_work: this.newStudent.place_of_work.name,
          place_of_work: this.getplaceofWork,
          category_of_vulnerable_group:
            this.newStudent.category_of_vulnerable_group,
          genotype: this.newStudent.genotype,
          address: this.newStudent.address,
          agency_id: 4,
          enrolled_by: this.user.id,
        });
        this.$emit("add-item", studentsAdded[0]);

        localStorage.removeItem("snap");
        this.img = "";
        if (this.newStudent.plan_type == "Individual") {
          this.clear();
          this.showInput();
          this.$toasted.info("Client Added Successfully", {
            position: "top-center",
            duration: 3000,
          });
        } else {
          this.modalShow = true;
          this.gotoDependent = true;
        }
      } catch (ex) {
        alert(ex.message);
      }
    },

    checkEnrollee() {
      this.isLoading = true;
      let total_total = [];
      if (this.newStudent.sector == "State Civil Servant") {
        total_total = this.all_formal_workers_state;
      }

      if (this.newStudent.sector == "LGA Civil Servant") {
        total_total = this.all_formal_workers_lga;
      }

      if (this.newStudent.sector == "Universal Basic Education") {
        total_total = this.ubec_formal_workers_lga;
      }
      if (this.newStudent.sector == "Organized Private Sector") {
        total_total = this.ops_staff;
      }

      let formatter = total_total.filter(
        (x) => x.CompNo == this.newStudent.salary_number
      );
      console.log(formatter);
       this.validated_enrollee = formatter;
      // let enrollee = this.selected_enrollee;
      if (this.validated_enrollee != null) {
        this.isLoading = false;
        this.showform = true;
        this.$toasted.success(`User Fetched Successfully!`, {
          position: "top-center",
          duration: 3000,
        });

       
      } else {
        this.isLoading = false;
        this.showform = false;
        this.$toasted.error(`Enrollee not found`, {
          position: "top-center",
          duration: 3000,
        });
      }
    },

    selectEnrollee(enrollee){
      this.newStudent.firstname = enrollee.firstname;
        this.newStudent.lastname = enrollee.lastname;
        this.newStudent.middlename = enrollee.middlename;
        this.newStudent.salary_number = enrollee.CompNo;
        this.newStudent.phone_number = enrollee.phone_number;
        this.newStudent.nimc_number = enrollee.nin_number;
        this.newStudent.marital_status = enrollee.marital_status;
        this.newStudent.email = enrollee.email;
    },

    closeDep() {
      this.clear();
      this.modalShow = true;
      this.showInput();
    },

    clear() {
      this.newStudent = {
        name: "",
        gender: "",
        client_number: "0",
        country: "",
        city: "",
      };
      localStorage.removeItem("snap");
      this.img = "";
      this.client_number = "0";
      this.showcanvas = false;
    },

    async remove(student) {
      if (confirm('Are you sure you want to delete? to "Confirm upload?')) {
        const service = new StudentService();
        service;
        this.disabled = false;
        const noOfStudentRemoved = await this.service.removeStudent(student.id);
        if (noOfStudentRemoved > 0) {
          this.$emit("remove-item");
          console.log(noOfStudentRemoved);
        }
      }
    },
    async removesync(student) {
      const service = new StudentService();
      service;
      this.disabled = false;
      const noOfStudentRemoved = await this.service.removeStudent(student.id);
      if (noOfStudentRemoved > 0) {
        this.$emit("remove-item");
        console.log(noOfStudentRemoved);
      }
    },
    async update(id) {
      id;
      // debugger;
      const noOfStudentsUpdated = await this.service.updateStudentById(
        this.editStudent
      );
      if (noOfStudentsUpdated > 0) {
        this.cancelUpdate();
        this.$emit("update-item");
      }
    },
    cancelUpdate() {
      this.editStudent = {};
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      console.log(this.img);
    },
    onStarted(stream) {
      console.log("On Started Event", stream);
    },
    onStopped(stream) {
      console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onRetake() {
      this.cameraready = true;
      this.pictureready = false;
    },
    onError(error) {
      console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },
  },
  created() {
    //
  },
};
</script>
<style scoped>
.spacer {
  margin-left: 5px;
  margin-top: 5px;
}

#videoElement {
  width: 500px;
  height: 375px;
  background-color: #666;
}
</style>
